import {
  getUnlinkPhotosFromAssetMutationOptions,
  getUnlinkPhotosFromWorkTaskMutationOptions,
} from 'api-client';
import { defaultMutationOptions, MutationOptions } from './mutations.interface';
import AssetRepository from 'assetClass/infrastructure/assetClass/asset/repository';
import PhotoRepository from 'assetClass/infrastructure/assetClass/assetPhotos/repository';
import WorkTaskPhotoRepository from 'common/infrastructure/work-task/workTaskPhotos/repository';
import {
  getCompleteWorkTaskMutationConfig,
  getRestartWorkTaskMutationConfig,
} from 'common/infrastructure/work-task/work-task-mutations';
import InspectionPhotoRepository from 'common/infrastructure/inspection/inspectionPhotos/repository';
import { getSubmitInspectionMutationConfig } from 'common/infrastructure/inspection/inspection-mutations';

export const getMutations = (): MutationOptions[] => [
  AssetRepository.getCreateAssetMutationConfig(),
  AssetRepository.getUpdateAssetMutationConfig(),
  getCompleteWorkTaskMutationConfig(),
  getRestartWorkTaskMutationConfig(),
  getUnlinkPhotosFromAssetMutationOptions({
    mutation: {
      ...defaultMutationOptions,
      ...PhotoRepository.getUnlinkPhotosFromAssetMutationCallbacks(),
    },
  }) as MutationOptions,
  getUnlinkPhotosFromWorkTaskMutationOptions({
    mutation: {
      ...defaultMutationOptions,
      ...WorkTaskPhotoRepository.getUnlinkPhotosFromWorkTaskMutationCallbacks(),
    },
  }) as MutationOptions,
  PhotoRepository.getUploadPhotoToAssetMutationConfig(),
  PhotoRepository.getLinkPhotosToAssetMutationConfig(),
  WorkTaskPhotoRepository.getUploadPhotoToWorkTaskMutationConfig(),
  InspectionPhotoRepository.getUploadPhotoToInspectionMutationConfig(),
  getSubmitInspectionMutationConfig(),
];
